
export type ColumnAction = 'M' | 'D';

export enum COLUMN_ACTION {
    CHECK = 'M',
    UNCHECK = 'D',
}